import { getClientConfigValue } from '../config/client.config';
export const computePrice = function (price, discount1, discount2) {
  let extraData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  let precision = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2;
  if (getClientConfigValue('productPricing.strategy') === 'price-inquiry') {
    // Price inquiry strategy: uses pre-calculated rabatUkupno_IZN or similar
    // If rabatUkupno_IZN is present, we might need to derive the unit price
    // But typically computePrice returns the unit price.
    // The provided strategy says: krajnjaCenaBezPdv = item.nettoVpc ?? item.cijena
    const nettoVpc = extraData.nettoVpc;
    if (nettoVpc !== undefined && nettoVpc !== null) {
      return parseFloat(nettoVpc).toFixed(precision);
    }
  }

  // Default strategy (Compound discount)
  if (!discount2) discount2 = 0;
  const baseDiscountApplied = price - percentageValue(price, discount1);
  const actionDiscountApplied = baseDiscountApplied - percentageValue(baseDiscountApplied, discount2);
  const rounded = actionDiscountApplied.toFixed(precision);
  return rounded;
};
export const percentageValue = (num, per) => {
  return num / 100 * per;
};
export const getOrderTotal = function (items) {
  let priceKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'price';
  if (!items || items.length === 0) return 0;
  return items.reduce((a, b) => a + b[priceKey] * b.quantity, 0);
};